import { render, staticRenderFns } from "./FilterUserTag.vue?vue&type=template&id=3a620588"
import script from "./FilterUserTag.vue?vue&type=script&lang=js"
export * from "./FilterUserTag.vue?vue&type=script&lang=js"
import style0 from "./FilterUserTag.vue?vue&type=style&index=0&id=3a620588&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports